import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'

import
  ElementUI
 from 'element-ui'

Vue.use(ElementUI);
